/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ParameterCombinationTableDto } from './ParameterCombinationTableDto';
import {
    ParameterCombinationTableDtoFromJSON,
    ParameterCombinationTableDtoFromJSONTyped,
    ParameterCombinationTableDtoToJSON,
} from './ParameterCombinationTableDto';

/**
 * 
 * @export
 * @interface AllCombinationsDisabledExceptionDetails
 */
export interface AllCombinationsDisabledExceptionDetails {
    /**
     * 
     * @type {ParameterCombinationTableDto}
     * @memberof AllCombinationsDisabledExceptionDetails
     */
    combinationTable?: ParameterCombinationTableDto;
    /**
     * 
     * @type {string}
     * @memberof AllCombinationsDisabledExceptionDetails
     */
    $type?: AllCombinationsDisabledExceptionDetailsTypeEnum;
}


/**
 * @export
 */
export const AllCombinationsDisabledExceptionDetailsTypeEnum = {
    PtwPtw100AppZeroApplicationTaskItemComponentAllCombinationsDisabledExceptionDetailsPtwPtw100AppZeroApplication: 'Ptw.Ptw100.AppZero.Application.TaskItemComponent.AllCombinationsDisabledExceptionDetails, Ptw.Ptw100.AppZero.Application'
} as const;
export type AllCombinationsDisabledExceptionDetailsTypeEnum = typeof AllCombinationsDisabledExceptionDetailsTypeEnum[keyof typeof AllCombinationsDisabledExceptionDetailsTypeEnum];


/**
 * Check if a given object implements the AllCombinationsDisabledExceptionDetails interface.
 */
export function instanceOfAllCombinationsDisabledExceptionDetails(value?: unknown): value is AllCombinationsDisabledExceptionDetails {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AllCombinationsDisabledExceptionDetailsTypeEnum)[0];
}

export function AllCombinationsDisabledExceptionDetailsFromJSON(json: any): AllCombinationsDisabledExceptionDetails {
    return AllCombinationsDisabledExceptionDetailsFromJSONTyped(json, false);
}

export function AllCombinationsDisabledExceptionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllCombinationsDisabledExceptionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'combinationTable': !exists(json, 'combinationTable') ? undefined : ParameterCombinationTableDtoFromJSON(json['combinationTable']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function AllCombinationsDisabledExceptionDetailsToJSON(value?: AllCombinationsDisabledExceptionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'combinationTable': ParameterCombinationTableDtoToJSON(value.combinationTable),
        '$type': value.$type,
    });
}

